var _path, _path2, _path3, _path4, _path5, _circle, _path6, _path7, _rect, _rect2, _path8, _path9, _rect3, _rect4, _rect5, _circle2, _circle3, _circle4, _rect6, _rect7, _rect8, _circle5, _circle6, _circle7, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _path10, _circle8, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoAccessIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 807.45276,
    height: 499.98424,
    viewBox: "0 0 807.45276 499.98424",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ad903c08-5677-4dbe-a9c7-05a0eb46801f-145",
    "data-name": "Path 461",
    d: "M252.30849,663.16553a22.728,22.728,0,0,0,21.947-3.866c7.687-6.452,10.1-17.081,12.058-26.924l5.8-29.112-12.143,8.362c-8.733,6.013-17.662,12.219-23.709,20.929s-8.686,20.6-3.828,30.024",
    transform: "translate(-196.27362 -200.00788)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "a94887ac-0642-4b28-b311-c351a0f7f12b-146",
    "data-name": "Path 462",
    d: "M253.34651,698.41151c-1.229-8.953-2.493-18.02-1.631-27.069.766-8.036,3.217-15.885,8.209-22.321a37.13141,37.13141,0,0,1,9.527-8.633c.953-.6,1.829.909.881,1.507a35.29989,35.29989,0,0,0-13.963,16.847c-3.04,7.732-3.528,16.161-3,24.374.317,4.967.988,9.9,1.665,14.83a.9.9,0,0,1-.61,1.074.878.878,0,0,1-1.074-.61Z",
    transform: "translate(-196.27362 -200.00788)",
    fill: "#f2f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496.87431,505.52556a6.9408,6.9408,0,0,1-2.85071.67077l-91.60708,2.51425a14.3796,14.3796,0,0,1-.62506-28.75241l91.60729-2.51381a7.00744,7.00744,0,0,1,7.15064,6.8456l.32069,14.75586a7.01658,7.01658,0,0,1-3.99577,6.47974Z",
    transform: "translate(-196.27362 -200.00788)",
    fill: "#bcd530"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M379.332,698.59808H364.57245a7.00786,7.00786,0,0,1-7-7V568.58392a7.00785,7.00785,0,0,1,7-7H379.332a7.00786,7.00786,0,0,1,7,7V691.59808A7.00787,7.00787,0,0,1,379.332,698.59808Z",
    transform: "translate(-196.27362 -200.00788)",
    fill: "#bcd530"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M418.52435,698.59808H403.76459a7.00786,7.00786,0,0,1-7-7V568.58392a7.00785,7.00785,0,0,1,7-7h14.75976a7.00786,7.00786,0,0,1,7,7V691.59808A7.00787,7.00787,0,0,1,418.52435,698.59808Z",
    transform: "translate(-196.27362 -200.00788)",
    fill: "#bcd530"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 196.71571,
    cy: 182.69717,
    r: 51,
    fill: "#bcd530"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M410.30072,605.205H373.61127a43.27708,43.27708,0,0,1-37.56043-65.05664l51.30933-88.87012a6.5,6.5,0,0,1,11.2583,0l50.27612,87.08057A44.56442,44.56442,0,0,1,410.30072,605.205Z",
    transform: "translate(-196.27362 -200.00788)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M405.02686,404.114c3.30591-.0918,7.42029-.20655,10.59-2.522a8.13274,8.13274,0,0,0,3.20007-6.07275,5.47084,5.47084,0,0,0-1.86035-4.49315c-1.65552-1.39894-4.073-1.72706-6.67823-.96144l2.69922-19.72558-1.98144-.27149-3.17322,23.18994,1.65466-.75928c1.91834-.87988,4.55164-1.32763,6.188.05518a3.51514,3.51514,0,0,1,1.15271,2.89551,6.14686,6.14686,0,0,1-2.38122,4.52783c-2.46668,1.80176-5.74622,2.03418-9.46582,2.13818Z",
    transform: "translate(-196.27362 -200.00788)",
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 226.50312,
    y: 172.03238,
    width: 10.77161,
    height: 2,
    fill: "#2f2e41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 192.50312,
    y: 172.03238,
    width: 10.77161,
    height: 2,
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M380.99359,593.79839a6.94088,6.94088,0,0,1-.67077-2.85072l-2.51425-91.60708a14.3796,14.3796,0,0,1,28.75241-.62506l2.51381,91.60729a7.00744,7.00744,0,0,1-6.8456,7.15064l-14.75586.32069a7.01655,7.01655,0,0,1-6.47974-3.99576Z",
    transform: "translate(-196.27362 -200.00788)",
    fill: "#bcd530"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M388.25747,345.00549c6.19637,8.10336,16.033,13.53931,26.42938,12.25223,9.90031-1.22567,18.06785-8.12619,20.117-18.0055a29.66978,29.66978,0,0,0-7.79665-26.1905c-7.00748-7.37032-17.03634-11.335-26.96311-12.69456-18.80446-2.57537-38.1172,4.04852-52.33518,16.4023a64.1102,64.1102,0,0,0-16.69251,22.37513,62.72346,62.72346,0,0,0-5.175,27.07767c.54633,18.375,8.595,36.71479,22.48271,48.90083a63.37666,63.37666,0,0,0,5.40808,4.23578c1.58387,1.11112,3.08464-1.48868,1.51415-2.59042-14.222-9.977-23.29362-26.21093-25.78338-43.26844a59.92391,59.92391,0,0,1,14.05278-48.33971c11.48411-13.058,28.32271-21.54529,45.7628-22.30575,17.54894-.76521,39.47915,7.06943,42.7631,26.60435,1.47191,8.7558-1.801,17.95926-9.82454,22.3428-8.59053,4.69326-19.12416,2.76181-26.50661-3.29945a30.448,30.448,0,0,1-4.86258-5.01092c-1.157-1.51313-3.76387-.02044-2.59041,1.51416Z",
    transform: "translate(-196.27362 -200.00788)",
    fill: "#2f2e41"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "fc777aff-63b1-4720-84dc-e3a9c20790b9",
    "data-name": "ab2e16f2-9798-47da-b25d-769524f3c86f",
    x: 484.20919,
    y: 242.03206,
    width: 437.1948,
    height: 207.45652,
    transform: "translate(-238.48792 -95.97299) rotate(-8.21995)",
    fill: "#f1f1f1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "ecffa418-b240-4504-be04-512edea7ccda",
    "data-name": "bf81c03f-68cf-4889-8697-1102f95f97bb",
    x: 496.79745,
    y: 259.81556,
    width: 412.19197,
    height: 173.08746,
    transform: "translate(-238.57266 -95.95442) rotate(-8.21995)",
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "b49ce3f1-9d75-4481-986b-3b6beb000c79",
    "data-name": "f065dccc-d150-492a-a09f-a7f3f89523f0",
    x: 468.80837,
    y: 231.16611,
    width: 437.19481,
    height: 18.57334,
    transform: "translate(-223.58995 -99.25677) rotate(-8.21995)",
    fill: "#e5e5e5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "a4219562-805a-49cd-8b89-b1f92f7a9e75",
    "data-name": "bdbbf39c-df25-4682-8b85-5a6af4a1bd14",
    cx: 288.67474,
    cy: 71.34324,
    r: 3.4425,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "b0f6399c-6944-4f74-a888-473f61f9730c",
    "data-name": "abcd4292-0b1f-4102-9b5e-e8bbd87baabc",
    cx: 301.6071,
    cy: 69.47507,
    r: 3.4425,
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "b03f93dc-2c99-4323-9b17-02f51b8830c0",
    "data-name": "a3fb731e-8b3d-41ca-96f2-91600dc0b434",
    cx: 314.54005,
    cy: 67.6068,
    r: 3.4425,
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "a6067cfc-0392-4d68-afe4-e34d11a8f0ac",
    "data-name": "ab2e16f2-9798-47da-b25d-769524f3c86f",
    x: 370.25796,
    y: 100.18309,
    width: 437.1948,
    height: 207.45652,
    fill: "#e6e6e6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "ecd65817-7467-4dbd-a435-c0f1d9841c98",
    "data-name": "bf81c03f-68cf-4889-8697-1102f95f97bb",
    x: 382.75969,
    y: 117.97286,
    width: 412.19197,
    height: 173.08746,
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "eea6c39d-8a45-4eb1-bab9-6120f465de14",
    "data-name": "f065dccc-d150-492a-a09f-a7f3f89523f0",
    x: 370.07154,
    y: 88.19711,
    width: 437.19481,
    height: 18.57334,
    fill: "#cbcbcb"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "ab9e51f9-7431-4d30-8193-f9435a6bd5c3",
    "data-name": "bdbbf39c-df25-4682-8b85-5a6af4a1bd14",
    cx: 383.87383,
    cy: 99.11864,
    r: 3.4425,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "a54ed687-3b0d-413b-b405-af8897a5c032",
    "data-name": "abcd4292-0b1f-4102-9b5e-e8bbd87baabc",
    cx: 396.94043,
    cy: 99.11864,
    r: 3.4425,
    fill: "#fff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "fd1d2195-7e97-488f-8f4b-7061a06deb9a",
    "data-name": "a3fb731e-8b3d-41ca-96f2-91600dc0b434",
    cx: 410.00762,
    cy: 99.11864,
    r: 3.4425,
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 620.27691,
    y: 144.28855,
    width: 58.05212,
    height: 4.36334,
    fill: "#e6e6e6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 620.27691,
    y: 157.09784,
    width: 89.64514,
    height: 4.36332,
    fill: "#e6e6e6"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 621.20899,
    y: 169.29697,
    width: 73.05881,
    height: 4.36332,
    fill: "#e6e6e6"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 620.27691,
    y: 182.68222,
    width: 42.65054,
    height: 4.36332,
    fill: "#e6e6e6"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 620.27691,
    y: 195.75677,
    width: 64.37073,
    height: 4.36332,
    fill: "#e6e6e6"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 593.81776,
    y: 142.916,
    width: 7.10843,
    height: 7.10842,
    fill: "#e6e6e6"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 593.81776,
    y: 155.72527,
    width: 7.10843,
    height: 7.10841,
    fill: "#e6e6e6"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 593.81776,
    y: 167.92442,
    width: 7.10843,
    height: 7.10843,
    fill: "#e6e6e6"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 593.81776,
    y: 181.30967,
    width: 7.10843,
    height: 7.10843,
    fill: "#e6e6e6"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 593.81776,
    y: 194.38423,
    width: 7.10843,
    height: 7.10843,
    fill: "#e6e6e6"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 620.27691,
    y: 208.91306,
    width: 58.05212,
    height: 4.36332,
    fill: "#e6e6e6"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 620.27691,
    y: 221.72236,
    width: 89.64514,
    height: 4.36332,
    fill: "#e6e6e6"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 621.20899,
    y: 233.92149,
    width: 73.05881,
    height: 4.36332,
    fill: "#e6e6e6"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 620.27691,
    y: 247.30674,
    width: 42.65054,
    height: 4.36332,
    fill: "#e6e6e6"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 620.27691,
    y: 260.38129,
    width: 64.37073,
    height: 4.36332,
    fill: "#e6e6e6"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 593.81776,
    y: 207.54051,
    width: 7.10843,
    height: 7.10843,
    fill: "#e6e6e6"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 593.81776,
    y: 220.34979,
    width: 7.10843,
    height: 7.10841,
    fill: "#e6e6e6"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 593.81776,
    y: 232.54894,
    width: 7.10843,
    height: 7.10843,
    fill: "#e6e6e6"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 593.81776,
    y: 245.93419,
    width: 7.10843,
    height: 7.10843,
    fill: "#e6e6e6"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 593.81776,
    y: 259.00875,
    width: 7.10843,
    height: 7.10843,
    fill: "#e6e6e6"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 436.63003,
    y: 243.13905,
    width: 58.05213,
    height: 4.36333,
    fill: "#e6e6e6"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 428.86266,
    y: 254.4769,
    width: 73.05881,
    height: 4.36332,
    fill: "#e6e6e6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M699.66075,388.1056a37.91872,37.91872,0,0,1-55.87819,33.382l-.00736-.00737a37.907,37.907,0,1,1,55.88555-33.37461Z",
    transform: "translate(-196.27362 -200.00788)",
    fill: "#e6e6e6"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 465.67554,
    cy: 175.95347,
    r: 10.30421,
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M679.54362,407.55657a53.11056,53.11056,0,0,1-35.56788-.13775l-.00738-.0051,7.6766-15.15329h20.60841Z",
    transform: "translate(-196.27362 -200.00788)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M547.86351,482.19293c-17.96014,0-32.5719-15.52155-32.5719-34.60067,0-19.07858,14.61176-34.60014,32.5719-34.60014s32.5719,15.52156,32.5719,34.60014C580.43541,466.67138,565.82365,482.19293,547.86351,482.19293Zm0-60.4582c-13.13954,0-23.82929,11.59955-23.82929,25.85753s10.68975,25.85806,23.82929,25.85806,23.82928-11.60008,23.82928-25.85806S561.00305,421.73473,547.86351,421.73473Z",
    transform: "translate(-196.27362 -200.00788)",
    fill: "#bcd530"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M578.70786,542.49212h-61.6887a20.54138,20.54138,0,0,1-20.51852-20.51826V461.46391a14.06356,14.06356,0,0,1,14.04747-14.04774h74.6308a14.06356,14.06356,0,0,1,14.04747,14.04774v60.50995A20.54138,20.54138,0,0,1,578.70786,542.49212Z",
    transform: "translate(-196.27362 -200.00788)",
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M559.88461,481.84022a12.0211,12.0211,0,1,0-17.48524,10.69829v18.808h10.92827v-18.808A12.01088,12.01088,0,0,0,559.88461,481.84022Z",
    transform: "translate(-196.27362 -200.00788)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M578.27362,699.99212h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-196.27362 -200.00788)",
    fill: "#3f3d56"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAccessIcon);
export default __webpack_public_path__ + "static/media/no_access_icon.5d20a0cc1335ba6b36bc9147c2a33563.svg";
export { ForwardRef as ReactComponent };